<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Malzeme"
    }
</script>

<style scoped>

</style>